"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveCommentRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.RemoveCommentRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    appointmentId: (0, superstruct_1.string)(),
    commentId: (0, superstruct_1.string)(),
});
//# sourceMappingURL=RemoveCommentRequest.js.map